module.exports = __webpack_public_path__ + "img/179.salad_bar.49ec9054.svg";